"use strict";

import Vue from "vue";
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';
axios.defaults.headers.get['Pragma'] = 'no-cache, must-revalidate';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

if (localStorage.getItem("accessToken")) {
  _axios.defaults.headers.common["accessToken"] = localStorage.getItem(
    "accessToken"
  );
}

// stage서버용
// _axios.root = "https://stage-itmsugang.carrotenglish.net:";
// _axios.port = "1111";
// _axios.imageRoot = "https://stage-itmsugang.carrotenglish.net:1111";
// _axios.defaultUrl = "https://stage-itmsugang.carrotenglish.net";
// _axios.type = "stage"

// _axios.root = "http://localhost:"
// _axios.port = "2000"
// _axios.imageRoot = "http://localhost:80"

// 로컬서버용
// _axios.root = "http://stage-platform.carrotenglish.net:"
// _axios.port = "80"
// _axios.imageRoot = "http://localhost:80"

// 운영서버
// _axios.root = "https://apply.carrotglobal.com:"
// _axios.port = "8080"
// _axios.imageRoot = "https://apply.carrotglobal.com:8080"
// _axios.defaultUrl = "https://apply.carrotglobal.com"
// _axios.type = "apply"

if (location.href.includes("stage-itmsugang.carrotenglish.net") || location.href.includes("stage-itmsugang-admin.carrotenglish.net")) {
  // _axios.root = "https://stage-itmsugang.carrotenglish.net:";
  // _axios.port = "1111";
  // _axios.imageRoot = "https://stage-itmsugang.carrotenglish.net:1111";
  // _axios.preview = "https://stage-itmsugang.carrotenglish.net";
  // _axios.defaultUrl = "https://stage-itmsugang.carrotenglish.net";

  _axios.root = "https://stage-itmsugang-api.carrotenglish.net";
  _axios.port = "";
  _axios.imageRoot = "https://stage-itmsugang.carrotenglish.net";
  _axios.preview = "https://stage-itmsugang.carrotenglish.net";
  _axios.defaultUrl = "https://stage-itmsugang.carrotenglish.net"

} else if (location.href.includes('apply.carrotglobal.com') || location.href.includes('applyadmin.carrotglobal.com')) {
  // _axios.root = "https://apply.carrotglobal.com:";
  // _axios.port = "8080";
  // _axios.imageRoot = "https://apply.carrotglobal.com:8080";
  // _axios.preview = "https://apply.carrotglobal.com";
  // _axios.defaultUrl = "https://apply.carrotglobal.com"
  _axios.root = "https://apply-api.carrotglobal.com";
  _axios.port = "";
  _axios.imageRoot = "https://apply.carrotglobal.com";
  _axios.preview = "https://apply.carrotglobal.com";
  _axios.defaultUrl = "https://apply.carrotglobal.com"
} else if (location.href.includes('apply2.carrotglobal.com')) {
  _axios.root = "https://apply2-api.carrotglobal.com";
  _axios.port = "";
  _axios.imageRoot = "https://apply2.carrotglobal.com:8080";
  _axios.preview = "https://apply2.carrotglobal.com";
  _axios.defaultUrl = "https://apply2.carrotglobal.com"
} else if (location.href.includes('apply-test.carrotglobal.com') || location.href.includes('applyadmin-test.carrotglobal.com')) {
  _axios.root = "https://apply-test.carrotglobal.com:";
  _axios.port = "8080";
  _axios.imageRoot = "https://apply-test.carrotglobal.com:8080";
  _axios.preview = "https://apply-test.carrotglobal.com";
  _axios.defaultUrl = "https://apply-test.carrotglobal.com"
} else if (location.href.includes('localhost')) {
  // _axios.root = "http://localhost:"
  // _axios.port = "8080"
  // _axios.imageRoot = "http://localhost:8080"

  // _axios.root = "https://apply2-api.carrotglobal.com";
  // _axios.port = "";
  // _axios.imageRoot = "https://apply2.carrotglobal.com:8080";
  // _axios.preview = "https://apply2.carrotglobal.com";
  // _axios.defaultUrl = "https://apply2.carrotglobal.com"

  // _axios.root = "https://stage-itmsugang.carrotenglish.net:";
  // _axios.port = "1111";
  // _axios.imageRoot = "https://stage-itmsugang.carrotenglish.net:1111";
  // _axios.preview = "https://stage-itmsugang.carrotenglish.net";

  _axios.root = "https://stage-itmsugang-api.carrotenglish.net";
  _axios.port = "";
  _axios.imageRoot = "https://stage-itmsugang.carrotenglish.net";
  _axios.preview = "https://stage-itmsugang.carrotenglish.net";
  _axios.defaultUrl = "https://stage-itmsugang.carrotenglish.net"

  // _axios.root = "https://stage-itmsugang-api.carrotenglish.net";
  // _axios.port = "";
  // _axios.imageRoot = "https://stage-itmsugang-api.carrotenglish.net";
  // _axios.preview = "https://stage-itmsugang-api.carrotenglish.net";
  // _axios.defaultUrl = "https://stage-itmsugang-api.carrotenglish.net"

  /* _axios.root = "https://apply-api.carrotglobal.com";
  _axios.port = "";
  _axios.imageRoot = "https://apply.carrotglobal.com";
  _axios.preview = "https://apply.carrotglobal.com";
  _axios.defaultUrl = "https://apply.carrotglobal.com" */
} else {
  alert('axios.js 수정 후 이용하실 수 있습니다.')
  _axios.root = "https://stage----itmsugang.carrotenglish.net:";
  _axios.port = "1111";
  _axios.imageRoot = "https://stage----itmsugang.carrotenglish.net:1111";
  _axios.preview = "https://stage----itmsugang.carrotenglish.net";
}

_axios.interceptors.request.use(
  function(config) {
    if (!navigator.onLine) {
      alert("인터넷 연결이 원할하지 않습니다.\n네트워크 상태를 확인해주세요.");
      // localStorage.removeItem('userId')
      // localStorage.removeItem('accessToken')
      // _axios.defaults.headers.common['accessToken']
      // this.$router.push('/user/login')
    }
    // Do something before request is sent
    return config;
  },
  function(error) {
    if (!navigator.onLine) {
      alert("인터넷 연결이 원할하지 않습니다.\n네트워크 상태를 확인해주세요.");
      // localStorage.removeItem('userId')
      // localStorage.removeItem('accessToken')
      // _axios.defaults.headers.common['accessToken']
      // this.$router.push('/user/login')
    }
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
